// src/QuestionMark.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx } from "react/jsx-runtime";
var QuestionMark_default = createIcon({
  displayName: "QuestionMark",
  viewBox: "0 0 20 20",
  path: /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx("g", { id: "help_outline", children: /* @__PURE__ */ jsx(
    "path",
    {
      id: "Vector",
      d: "M9.16699 15.0003H10.8337V13.3337H9.16699V15.0003ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667ZM10.0003 5.00033C8.15866 5.00033 6.66699 6.49199 6.66699 8.33366H8.33366C8.33366 7.41699 9.08366 6.66699 10.0003 6.66699C10.917 6.66699 11.667 7.41699 11.667 8.33366C11.667 10.0003 9.16699 9.79199 9.16699 12.5003H10.8337C10.8337 10.6253 13.3337 10.417 13.3337 8.33366C13.3337 6.49199 11.842 5.00033 10.0003 5.00033Z",
      fill: "currentColor"
    }
  ) }) })
});

export {
  QuestionMark_default
};
